import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { refreshToken } from '../service/auth';
import { useSidebarStore } from '../store/useSidebar';
import { useUserStore } from '../store/useUser';
import { parseToken } from '../utils/token';

const AuthVerify = () => {
  const [loading, setLoading] = useState(false);

  const jwt = useUserStore(state => state.jwt)
  const setMenu = useSidebarStore(state => state.setMenu)

  const token = jwt?.access_token;
  const parsedToken = parseToken(token);

  useEffect(() => {
    if (loading) return

    if (!token) {
      setMenu()
      return 
    } 

    const fetchData = async () => {
      const { error: errorJwt, success: newJwt } = await refreshToken();

      if (errorJwt || !newJwt) {
        window.location.href = '/login';
        localStorage.clear()
        return false
      }

      return true
    }

    if (token && parsedToken?.exp < ((Date.now() / 1000) + 100)) {
      setLoading(true)

      const data = fetchData()
        .then((data) => {
          return data
        })
        .catch(err => {
          localStorage.clear()
        });
    }
  }, [loading, parsedToken?.exp, setMenu, token])
  return <></>;
};

export default AuthVerify;
